
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
    stats: {
      type: Object,
      required: true,
    },
    lastMatch: {
      type: Object,
      default: null,
    },
  },
  computed: {
    lastMatchStatTypes () {
      if (this.player?.position === `Goalkeeper`) {
        return this.additionalConfig?.player_stats_config?.last_match_stats_blocks_goalkeeper;
      }
      return this.additionalConfig?.player_stats_config?.last_match_stats_blocks;
    },
    filteredLastMatchStats () {
      const filteredStatBlocks = [];
      if (this.stats && this.lastMatchStatTypes) {
        const statBlocks = this.lastMatchStatTypes;
        for (const block of statBlocks) {
          if (this.stats[block]) {
            filteredStatBlocks.push({
              key: block,
              title: this.deslugify(block),
              stats: this.stats[block],
            });
          }
        }
      }
      return filteredStatBlocks;
    },
  },
  methods: {
    getComponentType (type) {
      return type === `performance`
        ? `RadarChart`
        : type === `passes_per_90`
          ? `PlayerPolarChart`
          : `PlayerStats${this.deslugify(type)}`;
    },
    getStats (block) {
      if (block.key === `performance`) {
        return [
          {
            value: Object.values(block.stats.last_match).map(stat => Math.round(stat.value * 10) / 10),
            name: `Last Match`,
          },
          {
            value: Object.values(block.stats.season_stats).map(stat => Math.round(stat.value * 10) / 10),
            name: `This Season`,
          },
        ];
      }
      return block.stats;
    },
    getTitles (block) {
      return block.key === `performance`
        ? Object.values(block.stats.last_match).map(stat => stat.displayName
          .replace(/Shot/g, `Shooting`)
          .replace(/Completed/g, ``)
          .replace(/Accuracy/g, ``)
          .replace(/Won/g, ``))
        : Object.values(block.stats).map(stat => stat.displayName);
    },
  },
};
